<template>
  <v-app>
    <!--
    <AppBarFrame
      :session="loadSession()"
      :environment="environment"
      :generalExApplicationEx="generalExApplicationEx"
    />

    <v-dialog
      transition="scale-transition"
      v-model="show"
      persistent
      scrollable
    >
      <v-card class="mx-auto">
        <Transaction
          :menu="{ transactionName: transactionName, selected: true }"
          :environment="environment"
          :generalExApplicationEx="generalExApplicationEx"
          :simpleHeader="true"
          :showSuccess="false"
          @transaction-process="transactionProcess"
          @close-dialog="closeDialog"
          ref="transactionRef"
        />

        <v-toolbar flat v-if="specificApp()">
          <v-spacer></v-spacer>
          <v-btn link color="transparent" elevation="0" :to="cancelLink()">
            <div class="text-caption text-capitalize">Cancel</div>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card>
    </v-dialog>
    -->
    <Authentication
      :register="null"
      :resetPassword="null"
      :cancel="'Cancel'"
      :success="true"
      :operationField="'appResetPassword'"
      :transactionField="'resetPasswordTran'"
      :registerField="null"
      :resetPasswordField="null"
      :maxWidth="'500'"
      @transaction-process="transactionProcess"
      @close-dialog="closeDialog"
    />
  </v-app>
</template>

<script>
//import Transaction from "./../transaction/Transaction";
import { environment } from "./../../../environment/environment.js";
//import AppBarFrame from "./../main/AppBarFrame";
import Authentication from './Authentication';
export default {
  name: "ResetPassword",
  props: [],
  data() {
    return {
      //show: true,
      //dialog: {},
      //generalExApplicationEx: {},
      environment: environment,
      //applicationName: null,
      //transactionName: null,
      resetPasswordSuccess: false
    };
  },
  components: {
    //Transaction,
    //AppBarFrame,
    Authentication
  },
  methods: {
    transactionProcess(data) {
      this.resetPasswordSuccess = data.success;
    },

    closeDialog(data) {
      if (this.resetPasswordSuccess) {
        this.goToLogin(data.applicationName)
      }
    },
  },
  created() {
  },
};
</script>

<style>
</style>